import React, { useState } from 'react';
import api from '../services/api';
import DateInput from '../components/DateInput';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [dob, setDob] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setMessage(null);

    if (!email || !dob) {
      setError('Please provide email and date of birth');
      return;
    }

    setLoading(true);
    try {
      const res = await api.post('/auth/forgot-password', { email, dob });
      setMessage(res.data.message || 'If the provided information is correct, a temporary password has been emailed');
      setEmail('');
      setDob('');
    } catch (err) {
      setError(err.response?.data?.error || err.message || 'Failed to reset password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container">
      <h2>Forgot Password</h2>
      <div className="form-container">
        {message && <div className="success-message">{message}</div>}
        {error && <div className="error-message">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Email</label>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)} required />
          </div>

          <div className="form-group">
            <DateInput label="Date of birth" value={dob} onChange={val => setDob(val)} required />
          </div>

          <button type="submit" className="add-action-button" disabled={loading}>{loading ? 'Processing...' : 'Send temporary password'}</button>
        </form>
      </div>
    </div>
  );
}
